import { API } from '../../core/http/api'

export async function postUsageData (usage) {
  const res = await API.post('onboarding/quick-setup', {
    usage
  })
  if (res.status !== 200) {
    throw new Error()
  }
  return res.data
}

export async function postBYODData (oldDomain, phoneNumber, timezone) {
  const res = await API.post('onboarding/byod-request', {
    oldDomain,
    phoneNumber,
    timezone
  })
  if (res.status !== 200) {
    throw new Error()
  }
  return res.data
}
